import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';
import styles from './Common.module.css';

class SpecTestsSIJTests extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_SIJTests' name='SIJ Tests' flagged={this.props.flagged}>
                
                     <div className={styles.sij_row}>
                        <div className={styles.flag} />
                        <div className={styles.label} />
                        <div className={styles.r_header}>R</div>
                        <div className={styles.c_header} />
                        <div className={styles.l_header}>L</div>
                     </div>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='SIJ Cluster' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELSIJGILLETSR === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELSIJGILLETSL === 1) {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'SIJTests'),
        flagged: flagCount >= 1 ? true : false
    };
}

const connectedSpecTestsSIJTests = connect(mapStateToProps)(SpecTestsSIJTests);
export { connectedSpecTestsSIJTests as SpecTestsSIJTests };



